import React, { useEffect, useContext, useState } from 'react'
import Icon from './Icon'
import { StateController } from './../../App';
import { sendDataLayer } from '../../utils/functions'

function CounterDown() {
  const [showResults, setShowResults] = useState(true)
  const { context } = useContext(StateController);
  
  useEffect(() => {
      const countDownDate = new Date('2026-01-15T23:59:59').getTime()      
      const startCountdown = () => {
        const timer = setInterval(function() {
          let now = new Date().getTime();
          let distance = countDownDate - now;
            
          if (distance < 0) {
            clearInterval(timer)
          }
        }, 1000)
      }
      startCountdown()
    
  }, [])

  const handler_notification_bar = (type) => {
    return () => {
      sendDataLayer({datalayer: {event: "notification_bar", text: type},repeat: true})
    }
  }

  const closeBanner = () => {
    console.log("cerrar banner");
    sendDataLayer({datalayer: {event: "close_notification_bar"},repeat: true})
    setShowResults(false)
  }

  return (
    <div> 
    {showResults && !context ? 
    <div className={`mc-counter-down`}>
      <div>
         <div id="countdown">
          {!context && <div className='mc-counter-down-container type_2'>
              <span className='terms_text'><strong>¿Sin código?</strong> 📲 Escríbenos por WhatsApp.  Elige <a onClick={handler_notification_bar("Exito")} href='https://wa.link/cin3ky' target="_blank" rel="noreferrer">Éxito</a> o <a href='https://wa.link/5ls8e7' onClick={handler_notification_bar("Carulla")} target="_blank" rel="noreferrer">Carulla</a> para obtenerlo e ingresar. </span>
                <span onClick={closeBanner} className='mc-counter-down-container__close'><Icon name="close_x" /></span>
              </div>
          }
          
        </div>
      </div>
    </div>
    : null }
    </div>
  )
}

export default CounterDown